import React, { Component } from "react"
import FormField from "../FormField"
import { InputNumber } from "formik-antd"

export default class AvgViews extends Component {
  render() {
    return (
      <FormField name={this.props.name || "metadata.avg_views"} label="Avg. Views">
        <InputNumber
          data-cy="account-avg-views"
          style={{ width: "100%" }}
          size="large"
          placeholder="1000"
        />
      </FormField>
    )
  }
}
